export const ANIMATION_TIME = 500;
